import { MemberSort, SortOrder } from '__generated__/graphql';
import { useEmployeeNameFormat } from 'hooks/settings';
import { EmployeeNameFormat } from 'hooks/settings/local-settings/useEmployeeNameFormat';
import { useCallback } from 'react';
import { isType } from 'utils/typeguard';

export function getApolloMemberNameSort(format: EmployeeNameFormat, direction: 'asc' | 'desc') {
  if (format === 'FIRST' || format === 'FIRST_LAST') {
    return [{ firstName: direction }, { lastName: direction }];
  } else {
    return [{ lastName: direction }, { firstName: direction }];
  }
}

export function getApolloNestedMemberNameSort(
  memberFieldName: string,
  format: EmployeeNameFormat,
  direction: 'asc' | 'desc'
) {
  if (format === 'FIRST' || format === 'FIRST_LAST') {
    return [{ [memberFieldName]: { firstName: direction } }, { [memberFieldName]: { lastName: direction } }];
  } else {
    return [{ [memberFieldName]: { lastName: direction } }, { [memberFieldName]: { firstName: direction } }];
  }
}

export default function useApolloMemberNameSort() {
  const [employeeNameFormat] = useEmployeeNameFormat();
  return useCallback(
    (direction: 'asc' | 'desc') => {
      return getApolloMemberNameSort(employeeNameFormat, direction);
    },
    [employeeNameFormat]
  );
}

export function useApolloNestedMemberNameSort(memberFieldName: string) {
  const [employeeNameFormat] = useEmployeeNameFormat();
  return useCallback(
    (direction: 'asc' | 'desc') => {
      return getApolloNestedMemberNameSort(memberFieldName, employeeNameFormat, direction);
    },
    [employeeNameFormat, memberFieldName]
  );
}

type FirstNameSort = { firstName: 'asc' | 'desc' };
type LastNameSort = { lastName: 'asc' | 'desc' };
type UntypedSort = FirstNameSort | LastNameSort;

export function convertMemberNameUntypedSortToTypedSort(sort: UntypedSort[]): MemberSort[] {
  if (sort.length === 0) {
    return [];
  }

  return sort.map((s) => {
    if (isType<FirstNameSort>(s, 'firstName')) {
      return { firstName: s.firstName === 'desc' ? SortOrder.Desc : SortOrder.Asc };
    } else {
      return { lastName: s.lastName === 'desc' ? SortOrder.Desc : SortOrder.Asc };
    }
  });
}
